export default "__VITE_ASSET__CNo86d7s__"